import { render } from "./PaymentPending.vue?vue&type=template&id=cc751140&ts=true"
import script from "./PaymentPending.vue?vue&type=script&lang=ts"
export * from "./PaymentPending.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__